export default "__VITE_ASSET__DUOPGAAt__"